import { Tag } from '@curri/components'
import { BracketsCurly, Flask, Key, type Icon } from '@phosphor-icons/react'

// The rest of the platform, as an index rather than cards — these are
// wayfinding notes, not calls to action, so they stay unlinked (the rail is
// the navigation). SDKs join this list when they exist.
const ITEMS: { icon: Icon; title: string; body: string; tag?: string }[] = [
  {
    icon: BracketsCurly,
    title: 'GraphQL playground',
    body: 'Run queries against the API in the browser.',
  },
  {
    icon: Key,
    title: 'API keys',
    body: 'Create, scope, and rotate credentials.',
  },
  {
    icon: Flask,
    title: 'Sandbox mode',
    body: 'Every endpoint works in test mode first.',
  },
]

export const AlsoInBuild = () => (
  <div style={{ marginTop: 48 }}>
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.08em',
        color: 'var(--curri-text-tertiary)',
      }}
    >
      ALSO IN BUILD
    </div>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
        gap: 24,
        marginTop: 18,
      }}
    >
      {ITEMS.map(item => (
        <div
          key={item.title}
          style={{ display: 'flex', flexDirection: 'column', gap: 7 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <item.icon
              size={18}
              style={{ color: 'var(--curri-text-secondary)' }}
            />
            <span style={{ fontSize: 14, fontWeight: 600 }}>{item.title}</span>
            {item.tag && <Tag color="warning" label={item.tag} />}
          </div>
          <div
            style={{
              fontSize: 13,
              lineHeight: 1.5,
              color: 'var(--curri-text-tertiary)',
            }}
          >
            {item.body}
          </div>
        </div>
      ))}
    </div>
  </div>
)
